<div class="flex flex-col flex-auto min-w-0">
    <div id="capture-pdf" class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between pb-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Rapport psychométrique</div>
            <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8">
                <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                    <button class="ml-4 hide-in-pdf" mat-flat-button [color]="'primary'" (click)="generatePDF()" [disabled]="isGeneratingPDF">
                        <mat-icon [svgIcon]="'heroicons_outline:printer'"></mat-icon>
                        <span class="ml-2 mr-1">PDF</span>
                    </button>
                    <button class="ml-4 hide-in-pdf" mat-flat-button [color]="'primary'" (click)="openActiviteAssechementModal()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1">Ajouter</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-auto">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid grid-cols-7 z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div class="ml-11">
                            Plan
                        </div>
                        <div>Pièces</div>
                        <div>Surface</div>
                        <div>Matériaux</div>
                        <div>Standard sec</div>
                        <div>Dernier rapport</div>
                        <div></div>
                    </div>
                    <ng-container *ngFor="let dossierInterventionActiviteAssechement of formatedActivitesAssechements;let index=index; trackBy: trackByFn">
                        <div *ngIf="index > 0" class="mx-auto border-top-pdf"></div>
                        <div class="cursor-pointer table-grid grid grid-cols-7 items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <div (click)="toggleChevron(index)" class="capitalize etage">
                                <button mat-icon-button class="hide-in-pdf">
                                    <mat-icon
                                        class="icon-size-4 text-current"
                                        [svgIcon]="chevronIsOpen(index) ? 'heroicons_solid:chevron-down' : 'heroicons_solid:chevron-right'"></mat-icon>
                                </button>
                                {{getEtageNom(dossierInterventionActiviteAssechement.etage_id)}}
                            </div>
                            <div (click)="toggleChevron(index)" class="capitalize">
                                {{getPieceNom(dossierInterventionActiviteAssechement.piece_id)}}
                            </div>
                            <div (click)="toggleChevron(index)" class="capitalize">
                                {{dossierInterventionActiviteAssechement.surface}}
                            </div>
                            <div (click)="toggleChevron(index)" class="capitalize">
                                {{dossierInterventionActiviteAssechement.material}}
                            </div>
                            <div (click)="toggleChevron(index)">
                                {{dossierInterventionActiviteAssechement.standard}} %
                            </div>
                            <div (click)="toggleChevron(index)">
                                {{dossierInterventionActiviteAssechement.last_report | date: 'YYYY/MM/dd'}}
                            </div>
                            <div (click)="openActiviteAssechementModal(dossierInterventionActiviteAssechement)">
                                <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            </div>
                        </div>

                        <div *ngIf="isGeneratingPDF || chevronIsOpen(index)" class="grid border-b bg-accent-50 pl-12">
                            <div class="table-grid grid grid-cols-7 items-center gap-4 py-3 px-6 md:px-8 text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5 border-b">
                                <div>
                                    Date
                                </div>
                                <div>Technicien</div>
                                <div>Humidité</div>
                                <div class="text-right col-span-3 hide-in-pdf">Détails</div>
                            </div>
                            <div
                                class="table-grid grid grid-cols-7 items-center gap-4 py-3 px-6 md:px-8"
                                *ngFor="let activiteAssechement of dossierInterventionActiviteAssechement.childrens"
                            >
                                <div class="capitalize">
                                    {{activiteAssechement.visit_date | date: 'YYYY/MM/dd'}}
                                </div>
                                <div class="capitalize">
                                    {{getTechnicienName(activiteAssechement.technicien_id)}}
                                </div>
                                <div class="capitalize">
                                    {{activiteAssechement.humidity}} %
                                </div>
                                <div class="text-right col-span-3 hide-in-pdf">
                                    <button
                                        mat-icon-button
                                        (click)="openActiviteAssechementModal(activiteAssechement, true)"
                                        [matTooltip]="'Enter edit mode'">
                                        <mat-icon
                                            class="icon-size-5 text-current"
                                            [svgIcon]="'heroicons_solid:pencil-alt'"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>

    <div class="sm:inset-0 flex flex-col flex-auto min-w-0 sm:overflow-hidden bg-card dark:bg-transparent">
        <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between pb-8 px-6 md:px-8 border-b ">
            <div class="text-4xl font-extrabold tracking-tight">Activité d'eaux</div>
            <div class="relative flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between py-8 px-6 md:px-8">
                <div class="flex shrink-0 items-center mt-6 sm:mt-0 sm:ml-4">
                    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="openActiviteEauModal()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1">Ajouter</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="flex flex-auto">
            <div class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                <div class="grid">
                    <div class="table-grid grid-cols-3 z-10 sticky top-0 grid gap-4 py-4 px-6 md:px-8 shadow text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <div class="ml-11">
                            Plan
                        </div>
                        <div>Pièces</div>
                        <div>Dernier rapport</div>
                    </div>
                    <ng-container *ngFor="let dossierInterventionActiviteEau of formatedActivitesEaux;let index=index; trackBy: trackByFn">
                        <div (click)="toggleChevron(index)" class="cursor-pointer table-grid grid grid-cols-3 items-center gap-4 py-3 px-6 md:px-8 border-b">
                            <ng-container *ngIf="dossierInterventionActiviteEau.etage_id === null && dossierInterventionActiviteEau.piece_id === null">
                                <div class="capitalize col-span-2">
                                    <button mat-icon-button>
                                        <mat-icon
                                            class="icon-size-4 text-current"
                                            [svgIcon]="chevronIsOpen(index) ? 'heroicons_solid:chevron-down' : 'heroicons_solid:chevron-right'"></mat-icon>
                                    </button>
                                    Extérieur
                                </div>
                            </ng-container>
                            <ng-container *ngIf="dossierInterventionActiviteEau.etage_id !== null && dossierInterventionActiviteEau.piece_id !== null">
                                <div class="capitalize">
                                    <button mat-icon-button>
                                        <mat-icon
                                            class="icon-size-4 text-current"
                                            [svgIcon]="chevronIsOpen(index) ? 'heroicons_solid:chevron-down' : 'heroicons_solid:chevron-right'"></mat-icon>
                                    </button>
                                    {{getEtageNom(dossierInterventionActiviteEau.etage_id)}}
                                </div>
                                <div class="capitalize">
                                    {{getPieceNom(dossierInterventionActiviteEau.piece_id)}}
                                </div>
                            </ng-container>

                            <div>
                                {{dossierInterventionActiviteEau.last_report | date: 'YYYY/MM/dd'}}
                            </div>
                        </div>

                        <div *ngIf="chevronIsOpen(index)" class="grid border-b bg-accent-50 pl-12">
                            <div class="table-grid grid grid-cols-5 items-center gap-4 py-3 px-6 md:px-8 text-md font-semibold text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5 border-b">
                                <div>
                                    Date
                                </div>
                                <div>Humidité relative</div>
                                <div>Température</div>
                                <div>GPL</div>
                                <div class="text-right">Détails</div>
                            </div>
                            <div
                                class="table-grid grid grid-cols-5 items-center gap-4 py-3 px-6 md:px-8"
                                *ngFor="let activiteEau of dossierInterventionActiviteEau.childrens"
                            >
                                <div class="capitalize">
                                    {{activiteEau.visit_date | date: 'YYYY/MM/dd'}}
                                </div>
                                <div class="capitalize">
                                    {{activiteEau.humidity}}
                                </div>
                                <div class="capitalize">
                                    {{activiteEau.temperature}}
                                </div>
                                <div class="capitalize">
                                    {{activiteEau.gpl}}
                                </div>
                                <div class="text-right">
                                    <button
                                        mat-icon-button
                                        (click)="openActiviteEauModal(activiteEau)"
                                        [matTooltip]="'Enter edit mode'">
                                        <mat-icon
                                            class="icon-size-5 text-current"
                                            [svgIcon]="'heroicons_solid:pencil-alt'"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
